import { ref } from "vue";
import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import type { Role } from "@/types/roles";
import { createToaster } from "@meforma/vue-toaster";
import { useRouter } from 'vue-router';
import type {CityProvince} from "@/types/cityProvince";

const router = useRouter();

export interface LoginFirstStepData {
  mobile: string;
  unique_id: string;
  device_name: string;
  device_model: string;
}

export interface LoginData {
  mobile: string;
  unique_id: string;
  code: string;
}

const defaultUser = {
  first_name: "",
  last_name: "",
  gender: "male",
  education: "",
  mobile: "",
  is_legal: 0,
  national_code: "",
  is_super_admin: false,
  image: "/media/avatars/300-1.jpg",
  roles: [] as Role[],
  city_id: -1,
  city: {
    id: -1,
    title: "",
    parent_id: -1,
    province: {
      id: -1,
      title: "",
      parent_id: -1
    }
  } as CityProvince,
};

//create a varibale to store the geolocation as lat long
const geographicaLocation = ref({
  lat: null,
  long: null,
});

/// define a varibale to handel number of localstorge conection
//const setLocalStorageHandeler = ref(false)

const localStorageLoction = JSON.parse(
  localStorage.getItem("location") as string
);

export const useAuthStore = defineStore("auth", () => {
  const errors = ref({});
  const user = ref(defaultUser);
  const isAuthenticated = ref(!!JwtService.getToken());



  // function setAuth(authUser: any) {
  //   isAuthenticated.value = true;
  //   user.value = {
  //     ...defaultUser,
  //     ...authUser.user,
  //     city: authUser.user.city || defaultUser.city, // اطمینان از وجود city
  //   };
  //   errors.value = {};
  //   JwtService.saveToken(authUser.token);
  //   localStorage.setItem("user", JSON.stringify(authUser.user));
  // }
  // function setAuth(authUser: any) {
  //   isAuthenticated.value = true;
  //   user.value = authUser.user;
  //   errors.value = {};
  //   JwtService.saveToken(authUser.token);
  //   localStorage.setItem("user", JSON.stringify(authUser.user));
  // }
  function setAuth(authUser: any) {
    isAuthenticated.value = true;
    user.value = {
      ...defaultUser,
      ...authUser.user,
      city: {
        ...defaultUser.city,
        ...(authUser.user.city || {}),
        province: {
          ...defaultUser.city.province,
          ...(authUser.user.city?.province || {})
        }
      }
    };
    errors.value = {};
    JwtService.saveToken(authUser.token);
    localStorage.setItem("user", JSON.stringify(user.value));
  }

  // function setUser(User: any) {
  //   isAuthenticated.value = true;
  //   user.value = User;
  //   const rolesId = user.value.roles.map((role) => role.id);
  // }
  function setUser(User: any) {
    isAuthenticated.value = true;
    user.value = {
      ...defaultUser,
      ...User,
      city: {
        ...defaultUser.city,
        ...(User.city || {}),
        province: {
          ...defaultUser.city.province,
          ...(User.city?.province || {})
        }
      }
    };
  }
  // function setUser(User: any) {
  //   isAuthenticated.value = true;
  //   user.value = {
  //     ...defaultUser,
  //     ...User,
  //     city: User.city || defaultUser.city, // اطمینان از وجود city
  //   };
  //   const rolesId = user.value.roles.map((role) => role.id);
  // }
  function isMultiCityUser(){
    const rolesId = user.value.roles.map((role) => role.id);
     const targetIds = [20, 14, 7, 1];
    return rolesId.some((id) => targetIds.includes(id));
  }

  function isSuperAdmin() {
    const rolesId = user.value.roles.map((role) => role.id);
    return rolesId.includes(1);
  }
  function isAdmin() {
    const rolesId = user.value.roles.map((role) => role.id);
    return rolesId.includes(2);
  }

  function isOperator() {
    const rolesId = user.value.roles.map((role) => role.id);
    return rolesId.includes(7);
  }

  function isReporter() {
    const rolesId = user.value.roles.map((role) => role.id);
    return rolesId.includes(10);
  }

  function isWareHouseKeeper() {
    const rolesId = user.value.roles.map((role) => role.id);
    return rolesId.includes(11);
  }

  function isDriverAdmin() {
    const rolesId = user.value.roles.map((role) => role.id);
    return rolesId.includes(18);
  }

  function setError(error: any) {
    if (typeof error === "object") {
      errors.value = { ...error };
    } else {
      errors.value = [error];
    }
  }

  function purgeAuth() {
    isAuthenticated.value = false;
    user.value = defaultUser;
    errors.value = [];
    JwtService.destroyToken();
    localStorage.setItem("user", JSON.stringify({}));
  }


  function loginFirstStep(credentials: LoginFirstStepData) {
    console.log("data", credentials);

    return ApiService.post("user-register", credentials)
      .then(({ data }) => {
        //  console.log(data);
      })
      .catch(({ response }) => {
        setError(response.data.state.msg);
      });
  }

  function login(credentials: LoginData) {
    return ApiService.post("verify", credentials)
      .then(({ data }) => {
        setAuth(data.data);
      })
      .catch(({ response }) => {
        console.log(response);

        setError(response.data.state.msg);

        const toaster = createToaster({
          type: "error",
          position: "top-right",
        });
        toaster.show(response.data.state.msg);
      });
  }
  function logout() {
    return ApiService.get("logout")
        .then(({ data }) => {
          // console.log("iiiii");
          window.location.href = '/sign-in';
          // router.push({ name: "sign-in" });
          window.location.reload();
          purgeAuth();

          const toaster = createToaster({
            type: "success",
            position: "top",
          });
          toaster.show(data.message || "با موفقیت خارج شدید");

        })
        .catch(({ response }) => {
          if (response.status === 401 ) {
            purgeAuth();
            window.location.href = '/sign-in';
          }
          // const toaster = createToaster({
          //   type: "error",
          //   position: "top-right",
          // });
          //
          // if (response?.data?.state?.msg) {
          //   toaster.show(response.data.state.msg);
          //   setError(response.data.state.msg);
          // } else {
          //   toaster.show("خطا در ارتباط با سرور");
          // }
        });
  }
  // function logout() {
  //   return ApiService.post("logout" , "logout")
  //       .then(({ data }) => {
  //         //  console.log(data);
  //       })
  //       .catch(({ response }) => {
  //         setError(response.data.state.msg);
  //
  //       });
  //   // purgeAuth();
  // }

  // function logout() {
  //   purgeAuth();
  // }
  function register(credentials: any) {
    return ApiService.post("register", credentials)
      .then(({ data }) => {
        setAuth(data);
      })
      .catch(({ response }) => {
        setError(response.data.errors);
      });
  }

  function forgotPassword(email: string) {
    return ApiService.post("forgot_password", email)
      .then(() => {
        setError({});
      })
      .catch(({ response }) => {
        setError(response.data.errors);
      });
  }

  function verifyAuth() {

    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("/auth", "user")
          .then(({ data }) => {
            if (localStorage.getItem("location") == null) {
              geographicaLocation.value.lat = data.data.city.center_lat;
              geographicaLocation.value.long = data.data.city.center_long;
              localStorage.setItem(
                  "location",
                  JSON.stringify(geographicaLocation.value)
              );
            }

          })
          .catch(({ response }) => {
            console.log(response);
            if (response.status === 401 ) {
              logout();
            }

            setError(response.state.error);
            purgeAuth();
          });
    } else {
      purgeAuth();
    }
  }

  function getUser() {
    if (user.value.hasOwnProperty("id")) {
      return user;
    } else {
    }
  }

  return {
    errors,
    user,
    isAuthenticated,
    isSuperAdmin,
    isMultiCityUser,
    isAdmin,
    isOperator,
    isReporter,
    isDriverAdmin,
    isWareHouseKeeper,
    loginFirstStep,
    logout,
    register,
    forgotPassword,
    verifyAuth,
    login,
    setUser,
    purgeAuth
  };
});
